import autocomplete from 'autocomplete.js';
import algoliasearch from 'algoliasearch';

export default {
    data() {
        return {
            autocomplete: null,
            query: '',
            hits: 5,
        };
    },
    watch: {
        value() {
            if (this.value) {
                this.query = this.value.name;
            }
        },
        query() {
            if (!this.query) {
                this.$emit('input', null);
            }
        },
    },
    methods: {
        parseLocationDetails(location) {
            const regExp = new RegExp(`(${this.query})`, 'gi');

            let countryName = location.country.name;

            if (location.country.localisations && typeof location.country.localisations[this.locale] !== 'undefined') {
                countryName = location.country.localisations[this.locale].name;
            }

            return [
                location.county ? location.county.replace(regExp, '<em>$1</em>') : '',
                location.country && location.country.data ? location.country.replace(regExp, '<em>$1</em>') : '',
                location.country && location.country ? countryName.replace(regExp, '<em>$1</em>') : '',
            ]
            .filter(entry => entry && entry.trim() != '')
            .join(', ');
        },
        highlightQuery(location) {
            let name = location.name;
            if (typeof location.localisations[this.locale] !== 'undefined') {
                name = location.localisations[this.locale].name;
            }
            if (this.isIe) {
                return name;
            }

            const regExp = new RegExp(`(${this.query})`, 'gi');

            return name.replace(regExp, '<em>$1</em>');
        },
    },
    computed: {
        pickupLocation: {
            get() {
                return this.$store.state.search.search.pickupLocation;
            }
        },
        locationSources() {
            if (!this.searchProviders) {
                return 'provider:WoS';
            } else if (typeof this.searchProviders == 'string') {
                return 'provider:' + this.searchProviders;
            } else if (
            Array.isArray(this.searchProviders) &&
            this.searchProviders.length > 0
            ) {
                return this.searchProviders.map(x => `provider:${x}`).join(' OR ');
            }

            return 'provider:WoS';
        },
        algoliaFilters() {
            return this.locationSources;
        },
    },
    mounted() {
        if (!this.autocomplete) {
            var client = algoliasearch(this.searchOptions.appId, this.searchOptions.apiKey);
            var index = client.initIndex(`${this.searchOptions.prefix}locations`);

            this.autocomplete = autocomplete(
            this.$refs.locationSearch,
            {
                autoselect: true,
                autoselectOnBlur: true,
                templates: {
                    dropdownMenu: '#location-search-template',
                    empty: '<div>'+ this.noResultsLabel +'</div>',
                },
            },
            [
                {
                    source: autocomplete.sources.hits(index, { hitsPerPage: this.hits, filters: this.algoliaFilters }),
                    name: 'd1',
                    displayKey: 'name',
                    templates: {
                        suggestion: suggestion => {
                            return `
                                  <div class="aa-suggestion-location">
                                    <span>${this.highlightQuery(suggestion)}</span>
                                  </div>
                                  <div class="aa-suggestion-extra-details">
                                    <span>${this.parseLocationDetails(suggestion)}</span>
                                  </div>
                                `;
                        },
                    },
                },
            ]
            ).on('autocomplete:selected', (event, suggestion, dataset) => {
                this.$store.dispatch('setPickupLocation', suggestion);
                this.$emit('locationSearch.pickUpLocation', suggestion);
                this.$emit('input', suggestion);
            });

            if (this.pickupLocationId) {
                index.getObject(
                    'WoS_' + this.pickupLocationId,
                    function(err, content) {
                        if (err) throw err;

                        this.autocomplete.autocomplete.setVal(content.name);
                        // this.$emit('locationSearch.dropOffLocation', suggestion);
                        this.$emit('input', content);
                    }.bind(this)
                );
            }
            else if (this.value) {
                index.getObject(
                    'WoS_' + this.value.id,
                    function(err, content) {
                        if (err) throw err;

                        this.autocomplete.autocomplete.setVal(content.name);
                        this.$emit('input', content);
                    }.bind(this)
                );
            }
        }
    }
}
